<template>
  <div
    tabindex="0"
    class="interaction-head display-minimum fill-in-the-blank fill-in-the-blank-display-minimum mb-0"
    :class="enabledFeatures.includes('hotspotStyling') ? '' : 'pt-2 px-2'"
    :aria-label="`Interaction text: ${interaction.interactionText.stripHTML(['img', 'Image'], 'input', 'Input blank')}`"
  >
    <div
      class="pp-interaction-title"
      v-html="interaction.interactionText"
    ></div>
    <InteractionAttachments :attachments="interaction.interactionAttachments" />
  </div>
</template>

<script>
import _ from 'lodash';
import InteractionAttachments from '../../Snippets/InteractionAttachments.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'FillInTheBlankDisplayMinimumInteractionHead',
  components: {
    InteractionAttachments,
  },
  mixins: [
    Interaction,
  ],
  props: {
    perspectiveKey: {
      type: String,
      required: true,
    },
    interactionBodyComponentKey: {
      type: String,
      required: true,
    },
  },
  computed: {
    selectedAnswers() {
      if (!_.get(this, 'interactionAttempt.responseText')) return [];
      return _.get(this, 'interactionAttempt.responseText', '').split(',');
    },
  },
  methods: {
    async initInputs() {
      await this.$nextTick();
      if (!this.$el || !this.$el.querySelectorAll) return;
      this.inputs = Array.from(this.$el.querySelectorAll('input'));
      for (const input of this.inputs) {
        input.placeholder = '';
      }
    },
  },
  async mounted() {
    await this.initInputs();
  },
  async updated() {
    await this.initInputs();
  },
};
</script>
